import { render, staticRenderFns } from "./EconfConfiguracaoForm.vue?vue&type=template&id=4d716483"
import script from "./EconfConfiguracaoForm.vue?vue&type=script&lang=js"
export * from "./EconfConfiguracaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports